import React, { createContext, useContext, useState, useMemo } from "react";
var HeaderContext = createContext({
    idSearchBarModal: undefined,
    setIdSearchBarModal: function () { },
    idMenuModal: undefined,
    setIdMenuModal: function () { },
    isOpenSearchBar: false,
    setIsOpenSearchBar: function () { },
    isOpenMenu: false,
    setIsOpenMenu: function () { },
    headerToolsLinksChildren: undefined,
    setHeaderToolsLinksChildren: function () { },
});
export var useHeaderContext = function () { return useContext(HeaderContext); };
export var HeaderProvider = function (_a) {
    var children = _a.children;
    var _b = useState(undefined), idSearchBarModal = _b[0], setIdSearchBarModal = _b[1];
    var _c = useState(undefined), idMenuModal = _c[0], setIdMenuModal = _c[1];
    var _d = useState(false), isOpenSearchBar = _d[0], setIsOpenSearchBar = _d[1];
    var _e = useState(false), isOpenMenu = _e[0], setIsOpenMenu = _e[1];
    var _f = useState(undefined), headerToolsLinksChildren = _f[0], setHeaderToolsLinksChildren = _f[1];
    var contextValue = useMemo(function () { return ({
        idSearchBarModal: idSearchBarModal,
        setIdSearchBarModal: setIdSearchBarModal,
        idMenuModal: idMenuModal,
        setIdMenuModal: setIdMenuModal,
        isOpenSearchBar: isOpenSearchBar,
        setIsOpenSearchBar: setIsOpenSearchBar,
        isOpenMenu: isOpenMenu,
        setIsOpenMenu: setIsOpenMenu,
        headerToolsLinksChildren: headerToolsLinksChildren,
        setHeaderToolsLinksChildren: setHeaderToolsLinksChildren,
    }); }, [idSearchBarModal, idMenuModal, isOpenSearchBar, isOpenMenu]);
    return React.createElement(HeaderContext.Provider, { value: contextValue }, children);
};
